import React from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import { Box, IconButton, Typography } from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
export default function Footer() {
    return (
        <>
            <Box marginY={"11vh"} display="flex" justifyContent="center">
                <IconButton
                    href="https://github.com/Kayosss"
                    target="_blank"
                    sx={{ mx: 1 }}
                >
                    <GitHubIcon sx={{ fontSize: 17 }} color="secondary" />
                </IconButton>
                <IconButton
                    href="https://www.linkedin.com/in/zachary-thalib-b799a5188/"
                    target="_blank"
                    sx={{ mx: 1 }}
                >
                    <LinkedInIcon sx={{ fontSize: 17 }} color="secondary" />
                </IconButton>
                <IconButton
                    href="https://www.instagram.com/kayos.ae"
                    target="_blank"
                    sx={{ mx: 1 }}
                >
                    <InstagramIcon sx={{ fontSize: 17 }} color="secondary" />
                </IconButton>
            </Box>
        </>
    );
}
